import { Box, Grid, Typography } from "@mui/material";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis, Cell } from "recharts";
import api from "../services/Axios";
import { useEffect, useState } from "react";

const EVENT_COLORS = {
    page_view: "#2979FF",
    scroll: "#66BB6A",
    session_start: "#EC407A",
    user_engagement: "#FFA726",
    first_visit: "#5C6BC0",
    onboarding_video_open: "#AB47BC",
    form_start: "#26A69A",
};
const CHART_STYLE = {
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    border: "1px solid #EEF0F5",
    boxShadow: "0 2px 8px rgba(17,19,26,0.04)",
};
export default function GoogleAnalytics({ dateRange, onLoadingChange }) {
    const [analyticsData, setAnalyticsData] = useState([]);
    const [loading, setLoading] = useState(true);

    const getAnalytics = async () => {
        const requestId = `google-analytics-${Date.now()}-${Math.random()}`;
        setLoading(true);
        onLoadingChange(requestId, true);
        try {
            const res = await api.get("/admin/analytics/ga/events", { params: dateRange });
            setAnalyticsData(res?.data?.rows || []);
        } finally {
            setLoading(false);
            onLoadingChange(requestId, false);
        }
    };

    useEffect(() => {
        getAnalytics();
    }, [dateRange, onLoadingChange]);

    return (
        <Grid item xs={12} md={6}>
            <Box borderRadius={2} p={2.5} sx={CHART_STYLE} height="100%">
                <Typography variant="h6" mb={2}>Event count</Typography>

                {!loading && (
                    <ResponsiveContainer width="100%" height={320}>
                        <BarChart data={analyticsData}>
                            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
                            <XAxis dataKey="event_name" stroke="#888" fontSize={12} />
                            <YAxis stroke="#888" fontSize={12} />
                            <Tooltip contentStyle={{ background: "#fff", border: "1px solid #333" }} />
                            <Bar dataKey="event_count" radius={[4, 4, 0, 0]}>
                                {analyticsData.map((row, i) => (
                                    <Cell key={i} fill={EVENT_COLORS[row.event_name] || "#999"} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                )}
            </Box>
        </Grid>
    );
}